export const smartTagTypes: Map<string, string> = new Map([
  ["cloudchipr_ttl", "Expiration"],
]);
